(function () {
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t.classList || !t.classList.contains('md-not-you')) {
            return;
        }
        e.preventDefault();
        var M = window.MDMeals;
        if (!M || !M.api) {
            return;
        }
        M.api('link/forget', { method: 'POST' })
            .then(function () {
                window.location.reload();
            })
            .catch(function (err) {
                alert(err.message || String(err));
            });
    });
})();
